export default "__VITE_ASSET__n4tUnmkL__"